/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_VendorUser_CreateUpdateVendorUserDto } from '../models/Wealthlane_CustomerService_Dtos_VendorUser_CreateUpdateVendorUserDto';
import type { Wealthlane_CustomerService_Dtos_VendorUser_VendorUserDto } from '../models/Wealthlane_CustomerService_Dtos_VendorUser_VendorUserDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VendorUserService {

    /**
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppVendorUserVendorUser(
        requestBody?: Wealthlane_CustomerService_Dtos_VendorUser_CreateUpdateVendorUserDto,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/vendor-user/vendor-user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_VendorUser_VendorUserDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppVendorUserVendorUser(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_VendorUser_VendorUserDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/vendor-user/vendor-user',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_CustomerService_Dtos_VendorUser_VendorUserDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppVendorUserVendorUserById(
        id: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_VendorUser_VendorUserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/vendor-user/{id}/vendor-user-by-id',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppVendorUserValidateAddVendorUser(
        requestBody?: Wealthlane_CustomerService_Dtos_VendorUser_CreateUpdateVendorUserDto,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/vendor-user/validate-add-vendor-user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
